import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import LazyLoad from 'react-lazyload';
import { useStyles } from './styles';
import Image from 'next/image';

export default function PharmaceuticalCompaniesMobile() {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor="#EEEEEE" pt={3}>
        <Container>
          <Typography className={classes.title} component="h2">
            <b>
              Mind the Graph's trusted by researchers and professionals
              <br /> from 100+ biotechnology and pharmaceutical companies
            </b>
          </Typography>

          <Box className={classes.mainBoxImages} pt={2}>
            <Image
              src="/images/logos-academics-institutions/novartis-icon.png"
              alt="novartis icon"
              loading="lazy"
              width={114}
              height={29}
            />

            <Image
              src="/images/logos-academics-institutions/sanofi-icon.png"
              alt="sanofi icon"
              loading="lazy"
              width={87}
              height={19}
            />

            <Image
              src="/images/logos-academics-institutions/pfizer-icon.png"
              alt="pfizer icon"
              loading="lazy"
              width={43}
              height={28}
            />

            <Image
              src="/images/logos-academics-institutions/novo-nordisk-icon.png"
              alt="nordisk icon"
              loading="lazy"
              width={68}
              height={49}
            />
          </Box>

          <Box className={classes.mainBoxImages} pt={2}>
            <Image
              src="/images/logos-academics-institutions/edanz-logo.png"
              alt="edanz icon"
              loading="lazy"
              width={94}
              height={22}
            />

            <Image
              src="/images/logos-academics-institutions/astrazeneca-icon.png"
              alt="astrazeneca icon"
              loading="lazy"
              width={112}
              height={31}
            />

            <Image
              src="/images/logos-academics-institutions/ipsen-icon.png"
              alt="ipsen icon"
              loading="lazy"
              width={76}
              height={22}
            />
          </Box>

          <Box className={classes.mainBoxImages} pt={2}>
            <Image
              src="/images/logos-academics-institutions/servier-icon.png"
              alt="servier icon"
              loading="lazy"
              width={76}
              height={25}
            />

            <Image
              src="/images/logos-academics-institutions/gsk-icon.png"
              alt="gsk icon"
              loading="lazy"
              width={112}
              height={45}
            />

            <Image
              src="/images/logos-academics-institutions/solvay-icon.png"
              alt="solvay icon"
              loading="lazy"
              width={54}
              height={54}
            />
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}
